import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/escalation/importer/escalationImporterActions';

export default importerReducers(actions);
